/* eslint-disable ember/no-mixins */
import Controller from '@ember/controller';
import EditPostMixin from '@linc-technologies/linced-common/mixins/edit-post';
import { service } from '@ember/service';

export default class PostController extends Controller.extend(EditPostMixin) {
  @service
  session;
}
